import { useContext, useEffect } from "react";
import { JoyrideContext } from "./JoyrideContext";
import { useIsJoyrideEnabled } from "./joyrideHooks";

export function JoyrideActivator() {
  const { toggleJoyride, activateJoyride, isJoyrideActive, runJoyride } =
    useContext(JoyrideContext);

  const isEnabled = useIsJoyrideEnabled();
  useEffect(() => {
    if (isJoyrideActive && !runJoyride) {
      toggleJoyride(true);
    }
  }, [toggleJoyride, isJoyrideActive, runJoyride]);

  useEffect(() => {
    if (isEnabled && !isJoyrideActive) {
      activateJoyride(true);
    }
  });

  return null;
}
